import { render, staticRenderFns } from "./LegalDutyDependentChildFSSurvey.vue?vue&type=template&id=5dc2b670"
import script from "./LegalDutyDependentChildFSSurvey.vue?vue&type=script&lang=ts"
export * from "./LegalDutyDependentChildFSSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports